import { useFormContext, useWatch } from 'react-hook-form';
import Box from '@/components/UI/Box';
import Switch from '@/components/UI/Switch';
import Text from '@/components/UI/Text';
import Item from '../UI/PressableRow';
import Icon from '../Unistyles/Icon';
import type { TeamEditFormValues } from './Team.types';

export default function TeamEditInvite() {
  const { control, setValue } = useFormContext<TeamEditFormValues>();
  const isLocked = useWatch({ control, name: 'isLocked' });

  return (
    <Item
      onPress={async () => {
        setValue('isLocked', !isLocked, { shouldDirty: true });
      }}
    >
      <Box direction="horizontal" gap="lg" flex align="center">
        <Icon name="person-add-outline" />
        <Text>Invite Links {isLocked ? 'Disabled' : 'Enabled'}</Text>
      </Box>
      <Switch
        value={!isLocked}
        onValueChange={(inviteLinksEnabled) => {
          setValue('isLocked', !inviteLinksEnabled, { shouldDirty: true });
        }}
      />
    </Item>
  );
}
